import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const sliceSelector = (rootState: RootState) => rootState.auth;

export const selectAuthUpdateAvailable = createSelector(
  [sliceSelector],
  (auth) => auth.updateAvailable,
);

export const selectAuthCapricaGitSha = createSelector(
  [sliceSelector],
  (auth) => auth.capricaGitSha,
);
